<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Map'}" tag="li" class="breadcrumb-item">
						<a href="#">地圖</a>
					</router-link>
					<li class="breadcrumb-item active" aria-current="page">{{questAreaData.area_name}}
						<span v-if="questAreaData.area_id > 12000 && questAreaData.area_id < 13000">(HARD)</span>
						<span v-else-if="questAreaData.area_id > 13000 && questAreaData.area_id < 14000">(VH)</span>
					</li>
				</ol>
			</nav>
			<div class="modal fade" id="CheckStatus" tabindex="-1" role="dialog" aria-labelledby="CheckStatusLabel" aria-hidden="true">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="CheckStatusLabel">{{$t('ShowMob')}}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="item-box">
								<div v-if="Number(monsterData.unit_id) > 600000">
									<img :class="monsterData.atkType == 1 ? 'str' : 'magic'" width="65" class="aligncenter" v-lazy="'/static/images/unit/icon_shadow_'+ (Number(monsterData.unit_id)-500000+30) +'.png'" :title="'名稱: '+ monsterData.name + '\n類別: '+getEnemyType(monsterData.atkType)">
								</div>
								<div v-else>
									<img :class="monsterData.atkType == 1 ? 'str' : 'magic'" width="65" class="aligncenter" v-lazy="'/static/images/unit/icon_unit_'+ monsterData.unit_id +'.png'" :title="'名稱: '+ monsterData.name + '\n類別: '+getEnemyType(monsterData.atkType)">
								</div>
								Type: {{getEnemyType(monsterData.atkType)}} <br>
								Name: {{monsterData.name}} <br>
								ＨＰ: {{monsterData.hp}}<br>
								<div v-if="monsterData.atk != 0">
									ATK: {{monsterData.atk}} <br>
								</div>
								DEF: {{monsterData.def}}<br>
								<div v-if="monsterData.magic_str != 0">
									Magic ATK: {{monsterData.magic_str}} <br>
								</div>
								Magic DEF: {{monsterData.magic_def}}<br>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="pcbtn" data-dismiss="modal">Close</button>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-12 col-md-12 col-12">
					<div class="item-box">
						<h2 class="">
							<div class="row">
								<div class="col-lg-6 col-md-7 col-12 mb-3">
									{{questAreaData.area_name}}
									<span v-if="questAreaData.area_id > 12000 && questAreaData.area_id < 13000">(HARD)</span>
									<span v-else-if="questAreaData.area_id > 13000 && questAreaData.area_id < 14000">(VH)</span>
								</div>
								<div class="col-lg-6 col-md-5 col-12 text-right mb-3">
									<router-link tag="button" class="float-lg-right pcbtn mr-3" :to="{ name: 'MapExtraDrop'}" v-if="questAreaData.area_id >= 11037 && questAreaData.area_id < 12000">
										37 {{$t('Area')}} ↑ {{$t('ExtraDrop')}}
									</router-link>
									<button class="float-lg-right pcbtn mr-3" :class="monster ? 'active':''" @click="showMonster">{{$t('ShowMob')}}</button>
								</div>
							</div>
						</h2>
						<div class="mb-3">
							<a target="_blank" href="https://priconne-redive.jp/news/update/19627/">2022/10/15 main quest drop rate update 36% -> 54% / 24% -> 36%</a>
						</div>
						<div class="overflow-auto">							
							<table width="1000px" class="table table-bordered mapTb">
								<tbody>
									<tr>
										<th>{{$t('Quest')}} <span class="small" v-if="clientWidth < 1000"> scroll →</span></th>
									</tr>
									<tr v-for="quest in questDropData" v-if="quest.quest_drop_item_list.length > 0" :key="quest.quest_id">
										<td>
											<h3 class="item-title">{{getQuestNumber(quest.quest_name)}}</h3>
											<div class="d-inline-flex justify-content-center" v-if="monster">
												<div v-for="item in quest.enemyList">
													<div class="p-1 mosterImg" @click="checkMonster(item)" data-toggle="modal" data-target="#CheckStatus">
														<div v-if="Number(item.unit_id) > 600000">
															<img :class="item.atkType == 1 ? 'str' : 'magic'" width="65" class="aligncenter" v-lazy="'/static/images/unit/icon_shadow_'+ (Number(item.unit_id)-500000+30) +'.png'" :title="'名稱: '+ item.name + '\n類別: '+getEnemyType(item.atkType)">
														</div>
														<div v-else>
															<img :class="item.atkType == 1 ? 'str' : 'magic'" width="65" class="aligncenter" v-lazy="'/static/images/unit/icon_unit_'+ item.unit_id +'.png'" :title="'名稱: '+ item.name + '\n類別: '+getEnemyType(item.atkType)">
														</div>
													</div>
												</div>
											</div>
											<div class="d-flex flex-nowrap">
												<div v-for="(item, index) in quest.quest_drop_item_list" class="p-1" :class="item.reward_type != 4 ? 'order-12' : 'order-1'">
													<template v-if="item.reward_type == 4">
														<router-link class="anm-grow" :to="{ name: 'EquipmentDetail', params: { id: item.reward_name }}">
															<img width="65" class="aligncenter" v-lazy="'/static/images/equipment/icon_equipment_'+ item.reward_id +'.png'">
														</router-link>
													</template>
													<template v-else>
														<img width="65" class="aligncenter" v-lazy="'/static/images/item/icon_item_'+ item.reward_id +'.png'">
													</template>
													<h6 class="text-center">{{item.odds}}%&nbsp;</h6>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="row">
							<div class="col-12 col-md-3 p-3" v-for="item in getMap">
								<router-link :to="{ name: 'MapDetail', params: { id: item.area_name+difficulty }}" class="btn p-3" style="width: 100%" :class="difficulty == 'N' ? 'btn-outline-info' : 'btn-outline-danger'">
									{{getI18nName(item,'area_name')}}
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import enemy_parameter from '../assets/edata/enemy_parameter.txt'
import ExtraDrop from "../assets/edata/extraDrop.json"
export default {
	name: 'MapDetail',
	props: ['clientWidth'],
	data() {
		return {
			questDropData: {},
			questAreaData: {},
			questRewardData: {},
			questRewardList: [],
			monsterData: {},
			mapId: "",
			difficulty: "",
			monster: false
		}
	},
	metaInfo() {
		return {
			title: this.questAreaData.area_name + " | 地圖資訊資訊 "
		}
	},
	methods: {
		getI18nName: function(item, name) {
			switch (this.locale) {
				case "jp":
					return item["jp_" + name]
					break
				default:
					return item[name]
					break
			}
		},
		getQuestNumber: function(name) {
			name = name.split(/\s+/);
			if (name[1] == null) {
				return name[0];
			}
			return name[1];
		},
		showMonster: function() {
			this.monster = !this.monster;
		},
		replaceDot: function(item) {
			var map = item.split(".");
			return map[1];
		},
		checkMonster: function(item) {
			this.monsterData = item;
		},
		getData: function(mapId) {
			var self = this;
			var questAreaData = this.$store.getters.getQuestAreaData;
			questAreaData = _.find(questAreaData, ['area_id', mapId]);
			self.questAreaData = questAreaData;
		},
		getQuestReward: function() {
			var self = this;
		},
		getEnemyType: function(type) {
			var self = this;
			if (type == 0) {				
				return this.$t('Magic');
			} else {
				return this.$t('Combat');
			}
		},
		getEqName: function(eq_id) {
			var self = this;
			var eq = _.find(self.$store.getters.getEquipmentCraft, function(o) {
				return o.condition_equipment_id_1 == eq_id;
			});
			if (eq) {
				var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
					return o.equipment_id == eq.equipment_id;
				});
				return eqData.equipment_name;
			} else {
				var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
					return o.equipment_id == eq_id;
				});
				return eqData.equipment_name;
			}
		},
		getQuest: function(mapId) {
			var self = this;
			var questDropData = this.$store.getters.getQuestData;
			var waveGroupData = this.$store.getters.getWaveGroupData;
			var enemyRewardData = this.$store.getters.getEnemyRewardData;
			var enemyParameter = JSON.parse(self.atou(enemy_parameter));
			var questRewardList = _.filter(questDropData, function(o) {
				return o.area_id.toString() == mapId.toString();
			});
			if (mapId == "18001") {
				var wave18001 = [{
						"area_id": "18001",
						"enemy_image_1": "108010208",
						"enemy_image_2": "108010201",
						"enemy_image_3": "108010205",
						"enemy_image_4": "108010207",
						"enemy_image_5": "0",
						"quest_id": "18001003",
						"quest_name": "聖跡調查(依等級掉落物品，級距不明)",
						"wave_group_id_1": "180010111",
						"wave_group_id_2": "180010112",
						"wave_group_id_3": "180010113"
					}, {
						"area_id": "18001",
						"enemy_image_1": "108010208",
						"enemy_image_2": "108010201",
						"enemy_image_3": "108010205",
						"enemy_image_4": "108010207",
						"enemy_image_5": "0",
						"quest_id": "18001004",
						"quest_name": "聖跡調查(依等級掉落物品，級距不明)",
						"wave_group_id_1": "180010121",
						"wave_group_id_2": "180010122",
						"wave_group_id_3": "180010123"
					},
					{
						"area_id": "18001",
						"enemy_image_1": "108010208",
						"enemy_image_2": "108010201",
						"enemy_image_3": "108010205",
						"enemy_image_4": "108010207",
						"enemy_image_5": "0",
						"quest_id": "18001005",
						"quest_name": "聖跡調查(依等級掉落物品，級距不明)",
						"wave_group_id_1": "180010211",
						"wave_group_id_2": "180010212",
						"wave_group_id_3": "180010213"
					}, {
						"area_id": "18001",
						"enemy_image_1": "108010208",
						"enemy_image_2": "108010201",
						"enemy_image_3": "108010205",
						"enemy_image_4": "108010207",
						"enemy_image_5": "0",
						"quest_id": "18001006",
						"quest_name": "聖跡調查(依等級掉落物品，級距不明)",
						"wave_group_id_1": "180010221",
						"wave_group_id_2": "180010222",
						"wave_group_id_3": "180010223"
					},
					{
						"area_id": "18001",
						"enemy_image_1": "108010208",
						"enemy_image_2": "108010201",
						"enemy_image_3": "108010205",
						"enemy_image_4": "108010207",
						"enemy_image_5": "0",
						"quest_id": "18001007",
						"quest_name": "聖跡調查(依等級掉落物品，級距不明)",
						"wave_group_id_1": "180010311",
						"wave_group_id_2": "180010312",
						"wave_group_id_3": "180010313"
					}, {
						"area_id": "18001",
						"enemy_image_1": "108010208",
						"enemy_image_2": "108010201",
						"enemy_image_3": "108010205",
						"enemy_image_4": "108010207",
						"enemy_image_5": "0",
						"quest_id": "18001008",
						"quest_name": "聖跡調查(依等級掉落物品，級距不明)",
						"wave_group_id_1": "180010321",
						"wave_group_id_2": "180010322",
						"wave_group_id_3": "180010323"
					},
					{
						"area_id": "18001",
						"enemy_image_1": "108010208",
						"enemy_image_2": "108010201",
						"enemy_image_3": "108010205",
						"enemy_image_4": "108010207",
						"enemy_image_5": "0",
						"quest_id": "18001009",
						"quest_name": "聖跡調查(依等級掉落物品，級距不明)",
						"wave_group_id_1": "180010411",
						"wave_group_id_2": "180010412",
						"wave_group_id_3": "180010413"
					}, {
						"area_id": "18001",
						"enemy_image_1": "108010208",
						"enemy_image_2": "108010201",
						"enemy_image_3": "108010205",
						"enemy_image_4": "108010207",
						"enemy_image_5": "0",
						"quest_id": "18001010",
						"quest_name": "聖跡調查(依等級掉落物品，級距不明)",
						"wave_group_id_1": "180010421",
						"wave_group_id_2": "180010422",
						"wave_group_id_3": "180010423"
					},
					{
						"area_id": "18001",
						"enemy_image_1": "108010208",
						"enemy_image_2": "108010201",
						"enemy_image_3": "108010205",
						"enemy_image_4": "108010207",
						"enemy_image_5": "0",
						"quest_id": "18001011",
						"quest_name": "聖跡調查(依等級掉落物品，級距不明)",
						"wave_group_id_1": "180010511",
						"wave_group_id_2": "180010512",
						"wave_group_id_3": "180010513"
					}, {
						"area_id": "18001",
						"enemy_image_1": "108010208",
						"enemy_image_2": "108010201",
						"enemy_image_3": "108010205",
						"enemy_image_4": "108010207",
						"enemy_image_5": "0",
						"quest_id": "18001012",
						"quest_name": "聖跡調查(依等級掉落物品，級距不明)",
						"wave_group_id_1": "180010521",
						"wave_group_id_2": "180010522",
						"wave_group_id_3": "180010523"
					}
				]
				questRewardList = _.concat(questRewardList, wave18001);
			}

			_.forEach(questRewardList, function(value, index) {
				var waveGroupList = new Array;
				var waveDropList = new Array;
				var questDropItemList = new Array;
				var wg1, wg2, wg3;
				wg1 = _.find(waveGroupData, ['wave_group_id', value.wave_group_id_1]);
				wg2 = _.find(waveGroupData, ['wave_group_id', value.wave_group_id_2]);
				wg3 = _.find(waveGroupData, ['wave_group_id', value.wave_group_id_3]);

				waveGroupList.push(wg1, wg2, wg3);
				var enemyRewardList = new Array;
				var enemyList = new Array;
				_.forEach(waveGroupList, function(drop) {
					if (!drop) {
						return;
					}
					var i;
					for (i = 0; i <= 4; i++) {
						if (drop['drop_reward_id_' + (i + 1)] != 0) {
							enemyRewardList.push(drop['drop_reward_id_' + (i + 1)]);
						}
					}
					var j;
					for (j = 1; j <= 5; j++) {
						if (drop['enemy_id_' + j] != 0) {
							var enemy = _.find(enemyParameter, ['enemy_id', drop['enemy_id_' + j]]);
							var enemyData = enemy;
							if (enemy.magic_str != "0") {
								enemyData['atkType'] = 0;
							} else {
								enemyData['atkType'] = 1;
							}
							enemyList.push(enemyData);
						}
					}
				});
				value["enemyList"] = enemyList;
				_.forEach(enemyRewardList, function(ememyReward) {
					var erd;
					erd = _.find(enemyRewardData, ['drop_reward_id', ememyReward]);
					var i;
					for (i = 0; i <= 4; i++) {
						if (erd['reward_id_' + (i + 1)] != 0) {
							var dObj = {};
							dObj["reward_id"] = erd['reward_id_' + (i + 1)].toString();
							dObj["odds"] = erd['odds_' + (i + 1)];
							dObj["promotion_level"] = "1";
							if (erd['reward_type_' + (i + 1)] == "4") {
								dObj["reward_name"] = self.getEqName(erd['reward_id_' + (i + 1)]);
								let item = _.find(self.$store.getters.getEquipmentData, ["equipment_id", dObj["reward_id"]]);
								if (item) {
									dObj["promotion_level"] = item.promotion_level;
								} else {
									dObj["promotion_level"] = "0";
								}

							}
							dObj["reward_type"] = erd['reward_type_' + (i + 1)];
							dObj["reward_num"] = erd['reward_num_' + (i + 1)];
							questDropItemList.push(dObj);
						}
					}
				});
				questDropItemList = _.orderBy(questDropItemList, ['odds', 'reward_id'], ['desc', 'desc']);

				function promote(foo, arr) {
					for (var i = 0; i < arr.length; i++) {
						if (arr[i].reward_id === foo) {
							var a = arr.splice(i, 1); // removes the item
							arr.unshift(a[0]); // adds it back to the beginning
							break;
						}
					}
					// Matching item wasn't found. Array is unchanged, but you could do something
					// else here if you wish (like an error message).
				}
				for (let i = 5; i >= 0; i--) {
					if (value['reward_image_' + (i)] != 0) {
						promote(value['reward_image_' + (i)], questDropItemList);
					}
				}
				value["quest_drop_item_list"] = questDropItemList;
			});
			self.questDropData = questRewardList;
		}
	},
	created: function() {
		var self = this;
		var mapName = this.$route.params.id;
		var map = mapName.slice(0, -1);
		var difficulty = mapName.substring(mapName.length - 1);
		if (mapName.indexOf("VH") > -1) {
			map = mapName.slice(0, -2);
			difficulty = mapName.substring(mapName.length - 2);
		}
		self.difficulty = difficulty;
		var questAreaData = _.filter(this.$store.getters.getQuestAreaData, function(o) {
			return _.includes(o.area_name, map);
		});
		var mapId = "";
		switch (difficulty) {
			case "N":
				mapId = questAreaData[0].area_id;
				break;
			case "H":
				var mapData = _.find(questAreaData, function(o) {
					return o.area_id > 12000 && o.area_id < 13000;
				});
				mapId = mapData.area_id;
				break;
			case "VH":
				var mapData = _.find(questAreaData, function(o) {
					return o.area_id > 13000 && o.area_id < 14000;
				});
				mapId = mapData.area_id;
				break;
			default:
		}
		self.mapId = mapId;
	},
	watch: {
		$route(to, from) {
			var self = this;
			var mapName = this.$route.params.id;
			var map = mapName.slice(0, -1);
			var difficulty = mapName.substring(mapName.length - 1);
			if (mapName.indexOf("VH") > -1) {
				map = mapName.slice(0, -2);
				difficulty = mapName.substring(mapName.length - 2);
			}
			self.difficulty = difficulty;
			var questAreaData = _.filter(this.$store.getters.getQuestAreaData, function(o) {
				return _.includes(o.area_name, map);
			});
			var mapId = "";			
			switch (difficulty) {
				case "N":
					mapId = questAreaData[0].area_id;
					break;
				case "H":
					try {
						mapId = questAreaData[1].area_id;
					} catch (e) {
						mapId = questAreaData[0].area_id;
					}					
					break;
				case "VH":
					var vhData = _.find(questAreaData, function(o) {
						return Number(o.area_id) > 13000 && Number(o.area_id) < 14000;
					});
					mapId = vhData.area_id;
					break;
				default:
			}
			self.mapId = mapId.toString();
			this.getData(self.mapId);
			this.getQuest(self.mapId);
			var body = $("html, body");
			body.stop().animate({ scrollTop: 0 }, 500, 'swing', function() {});
		}
	},
	computed: {
		getMap: function() {
			var self = this;
			return _.filter(self.$store.getters.getQuestAreaData, function(o) {
				if (self.difficulty == "N" && self.mapId != "18001" && self.mapId != "19001") {
					return o.area_id < 12000;
				} else if (self.difficulty == "H") {
					return o.area_id > 12000 && o.area_id < 13000;
				} else if (self.difficulty == "VH") {
					return o.area_id > 13000 && o.area_id < 14000;
				} else if (o.area_id != "18001") {
					return o.area_id == "19001";
				} else {
					return o.area_id == "18001";
				}
			});
		},
		locale() {
			return this.$i18n.locale
		}
	},
	mounted: function() {
		var self = this;
		var mapId = self.mapId.toString();
		this.getData(mapId);
		this.getQuest(mapId);
	}
}
</script>
<style scoped>
.list-group-item {
	background-color: transparent;
}
</style>